// extracted by mini-css-extract-plugin
module.exports = {"trophyMemoryCardSkeleton__container":"TrophyMemoryCardSkeleton_trophy-memory-card-skeleton__container__XDf3w"};